import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, useTheme, Stack, CircularProgress } from '@mui/material';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import TopBar from '../../../components/TopBar';
import { useGetOrganizationHandler } from '../dataHandlers/getOrganizationHandler';
import OrganizationForm from '../components/OrganizationForm';

export default function OrganizationDetailsPage() {
  useDocumentTitle('Organization Details');
  const theme = useTheme();
  const navigate = useNavigate();

  const { id } = useParams();
  const { organization, isLoading } = useGetOrganizationHandler(id);

  function onClickingBackButton() {
    return navigate('/organizations');
  }

  if (isLoading || !organization) {
    return <CircularProgress />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {organization && (
        <Box sx={{ pb: 4 }}>
          <TopBar
            title="Organization Details"
            subTitle={organization?.stripe_customer_id}
            identifier={organization?.stripe_customer_id}
          >
            <Button
              data-testid="organization-profile-back-button"
              key="back"
              variant="contained"
              color="primary"
              onClick={onClickingBackButton}
              className="action-button"
              sx={{ marginLeft: theme.spacing(1) }}
            >
              Back
            </Button>
          </TopBar>
        </Box>
      )}
      <OrganizationForm initialData={organization} readOnly={true} edit={false} />
    </Stack>
  );
}
